import React, { useContext, useEffect } from 'react';
import { ISocialIframeProps } from './social-embed';
import { AmpPropsContext } from '../../context/amp-props/amp-props-provider';
import { IAmpPropsTag } from '../../typings/amp';
import { getAmpTag } from '../../utils/amp';
import { isClient } from '../../utils/device-utils';
import { addTwitterScript, getTweetId } from '../../utils/socials';
import AmpTwitter from '../amp/amp-twitter';

const TwitterBlock: React.FC<ISocialIframeProps> = ({ src, cookieAllowed }) => {
  const { ampProps, isAmp } = useContext(AmpPropsContext);

  const ampTwitter: IAmpPropsTag | undefined = getAmpTag(ampProps, 'twitter');
  const tweetId = getTweetId(src);

  useEffect(() => {
    if (isClient() && !isAmp && cookieAllowed) {
      addTwitterScript();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cookieAllowed]);

  return ampTwitter ? (
    <AmpTwitter
      tweetId={tweetId}
      width={ampTwitter.width}
      height={ampTwitter.height}
      layout={ampTwitter.layout}
      dataBlockOnConsent={ampTwitter.dataBlockOnConsent}
    />
  ) : (
    <blockquote className="twitter-tweet">
      <a href={src} />
    </blockquote>
  );
};

export default TwitterBlock;
